import React from 'react';
import loadable from '@loadable/component';
import ModalFallback from './ModalFallback';

const Modal = loadable(() =>
  import(/* webpackChunkName: "component-modal" */ 'react-modal').then(
    module => {
      try {
        module.default.setAppElement('#content');
      } catch (e) {
        console.error(e);
      }

      return module;
    }
  )
);

function getParent() {
  return document.body;
}

const LazyModal = props => (
  <Modal parentSelector={getParent} {...props} fallback={<ModalFallback />} />
);

export default LazyModal;
